import { render, staticRenderFns } from "./CustomDisplay.vue?vue&type=template&id=b863f9c4&"
import script from "./CustomDisplay.vue?vue&type=script&lang=js&"
export * from "./CustomDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CustomDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports